import Drawer from '@/component/Drawer'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector, PopUpStore } from '@/store/PopupStore'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ResetPasswordMain from './ResetPasswordMain'

const ResetPasswordPopup: React.FC<PropType> = () => {
  const { t } = useTranslation('uc')
  const resetPasswordPopupVisible = useStatePopup(PopupSelector.resetPasswordPopupVisible)

  const handleClose = () => {
    PopUpStore.setResetPasswordPopupVisible(false)
  }

  return (
    <Drawer
      visible={resetPasswordPopupVisible}
      zIndex={903}
      onClose={handleClose}
      lockScroll={true}
      destroyOnClose
      className="bg-primary-light"
      title={t('modalTitle.resetPassword')}
    >
      <div className="h-full px-md">
        <ResetPasswordMain />
      </div>
    </Drawer>
  )
}

interface PropType {}

export default ResetPasswordPopup
